export const FLAG_GETTING_ITINERARY_GROUPS = 'FLAG_GETTING_ITINERARY_GROUPS';
export const GET_ITINERARY_GROUPS = 'GET_ITINERARY_GROUPS';
export const CLEAR_ITINERARY_GROUPS = 'CLEAR_ITINERARY_GROUPS';
export const FLAG_ITINERARY_GROUP_ACTIVITY = 'FLAG_ITINERARY_GROUP_ACTIVITY';
export const GET_ITINERARY_GROUP = 'GET_ITINERARY_GROUP';
export const CLEAR_ITINERARY_GROUP = 'CLEAR_ITINERARY_GROUP';
